import { BOOTSTRAP_BREAKPOINTS, BREAKPOINT_ORDER, } from "./BootstrapBreakpoint.model";
export default class BootstrapBreakpointService {
    static getBreakpointForWidth(width) {
        const breakpointsReversed = BREAKPOINT_ORDER.slice().reverse();
        for (const breakpoint of breakpointsReversed) {
            if (BOOTSTRAP_BREAKPOINTS[breakpoint] < width) {
                return breakpoint;
            }
        }
        return null;
    }
    static getAllBreakpointsForWidth(width) {
        return Object.keys(BOOTSTRAP_BREAKPOINTS).reduce((obj, key) => (Object.assign(Object.assign({}, obj), { 
            // $FlowFixMe
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly sm: 576; readonly md: 768; readonly lg: 992; readonly xl: 1200; }'.
            [key]: width >= BOOTSTRAP_BREAKPOINTS[key] })), {});
    }
    static getBreakpointBefore(breakpoint) {
        if (!breakpoint) {
            return null;
        }
        const index = BREAKPOINT_ORDER.findIndex((b) => b === breakpoint);
        if (index < 1) {
            return null;
        }
        return BREAKPOINT_ORDER[index - 1];
    }
    static getAllBreakpointsBefore(breakpoint) {
        if (!breakpoint) {
            return [];
        }
        const index = BREAKPOINT_ORDER.findIndex((b) => b === breakpoint);
        if (index < 1) {
            return [];
        }
        return BREAKPOINT_ORDER.slice(0, index);
    }
    static isBreakpointBefore(breakpoint, before) {
        if (before == null) {
            // Nothing is before null
            return false;
        }
        const breakpointIndex = BREAKPOINT_ORDER.findIndex((b) => b === breakpoint);
        const beforeIndex = BREAKPOINT_ORDER.findIndex((b) => b === before);
        if (breakpoint == null && beforeIndex !== -1) {
            return true;
        }
        if (breakpointIndex === -1 || beforeIndex === -1) {
            return null;
        }
        return breakpointIndex < beforeIndex;
    }
}
